export default "__VITE_ASSET__4917eced__"